import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// ========== RESIZEOBSERVER ERROR HANDLER ==========
(function() {
  // Store originals
  const original = {
    error: console.error,
    warn: console.warn
  };

  // Function to detect if it's a ResizeObserver error
  const isResizeObserverError = (arg) => {
    if (!arg) return false;
    
    const str = String(arg).toLowerCase();
    return str.includes('resizeobserver loop completed with undelivered notifications');
  };

  // Override console.error for ResizeObserver errors only
  console.error = function(...args) {
    if (args.some(isResizeObserverError)) {
      // Silently ignore ResizeObserver errors - they're harmless
      return;
    }
    return original.error.apply(this, args);
  };

  // Override console.warn for ResizeObserver errors only
  console.warn = function(...args) {
    if (args.some(isResizeObserverError)) {
      // Silently ignore ResizeObserver warnings - they're harmless
      return;
    }
    return original.warn.apply(this, args);
  };
})();

// Render the app
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);
